import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { CoreEnumResponse } from './useCreateCoreEnum';

export interface UpdateCoreEnumData {
  name?: string;
  description?: string;
  isSystem?: boolean; // Only admins can toggle this
  areOptionsLocked?: boolean;
  options?: Array<{
    id?: string;
    name: string;
    description?: string | null;
    sortOrder: number;
  }>;
}

const useUpdateCoreEnum = (
  enumId: string,
  onSuccess?: (updated: CoreEnumResponse) => void,
) => {
  const queryClient = useQueryClient();

  return useMutationApi<UpdateCoreEnumData, CoreEnumResponse>({
    endpoint: `core/core-enums/${enumId}`,
    method: 'PUT',
    successMessage: 'Enum updated successfully',
    errorMessage: 'Failed to update enum',
    options: {
      onSuccess: (response) => {
        queryClient.invalidateQueries({ queryKey: ['core/core-enums'] });
        onSuccess?.(response.data);
      },
    },
  });
};

export default useUpdateCoreEnum;
